export default "/images/a05c50fb1f14ef767dc9a5de030e13f0.png";